import React, {useState, useEffect} from 'react';
import {useDispatch} from "react-redux";
import {useTranslation} from "react-i18next";
import {Button, Input, Flex} from "antd";
import {PlusOutlined} from "@ant-design/icons";

import SemiFinishedListComponent from "../SemiFinishedListcomponent/SemiFinishedListComponent";
import {semiFinishedActions} from "../../../store/slices/semiFinished-slice";
import {SemiFinishedCreateModal} from "../semiFenishedSectionModal";


const SemiFinishedComponent = () => {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        dispatch(semiFinishedActions.clearSearch());
    }, [dispatch]);

    const handleSearch = (value) => {
        dispatch(semiFinishedActions.filteredSemiFinished(value));
    };

    return (
        <section>
            <Flex
                justify="space-between"
                align="center"
                style={{padding: '12px 16px', borderBottom: '1px solid #e0e0e0'}}
            >
                <Button
                    type="primary"
                    icon={<PlusOutlined/>}
                    onClick={() => setIsOpen(true)}
                >
                    {t('button-create-text')}
                </Button>

                <Input.Search
                    placeholder={t('Search')}
                    allowClear
                    onChange={(e) => handleSearch(e.target.value)}
                    onSearch={handleSearch}
                    style={{width: 280}}
                />
            </Flex>

            <SemiFinishedListComponent/>

            {isOpen && <SemiFinishedCreateModal setIsOpen={setIsOpen}/>}
        </section>
    );
};

export {SemiFinishedComponent};